import Sinistro from "./sinistro";

export default Sinistro;
